module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('v-header', {
    attrs: {
      "title": _vm.title,
      "showMenuButton": false,
      "showBackButton": true,
      "showPostButton": false
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "login-detail"
  }, [_c('div', {
    staticClass: "login1"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.accesstoken),
      expression: "accesstoken"
    }],
    attrs: {
      "placeholder": "Access Token"
    },
    domProps: {
      "value": (_vm.accesstoken)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.accesstoken = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v("确定")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-90546678"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Login.vue
// module id = 144
// module chunks = 1